var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnniversariesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 37,
    viewBox: "0 0 21 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.463 9.96202C20.463 4.56172 15.9152 0.181519 10.3062 0.181519C4.69718 0.181519 0.152344 4.56172 0.152344 9.96202C0.152344 14.8802 3.92108 23.182 8.83044 24.6284L7.59869 26.2952C7.38115 26.5862 7.58987 27.0007 7.9544 27.0007H9.57419V35.4466C9.57419 35.8523 9.90345 36.1815 10.3091 36.1815C10.7148 36.1815 11.0441 35.8523 11.0441 35.4466V27.0007H12.6609C13.0166 27.0007 13.2253 26.6039 13.0284 26.3099L11.8789 24.599C16.7413 23.0732 20.463 14.8479 20.463 9.95908V9.96202Z",
    fill: "#3C3F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnniversariesIcon);
export default __webpack_public_path__ + "static/media/anniversaries-icon.516b916afdc7a887230f16e172f8e092.svg";
export { ForwardRef as ReactComponent };